import React from 'react';

import { ModalController, type ModalHandler } from './index';

const ModalFactory = <P extends Record<string, unknown>>(
  Component: React.ComponentType<{modal: ModalHandler} & P>,
) => {
  return ModalController.create<P>(Component);
};

export default ModalFactory;
